import * as d from '../desktop-fallback'
import { pascalToHuman } from '@/services/text/humanify'

// == MOBILE FALLBACK STYLES == //

export const stylingByEventType = {
  ApplicationSwitched: {
    title: () => ({ text: "App Switched" }),
    icon: () => 'window-restore',
  },
}

// mobile .type style mappings for fallback viewer
export const stylingByType = {
  Alert: d.dangerStyle,
  Bluetooth: {
    icon: () => ['fab', 'bluetooth'],
    iconClass: () => 'has-text-info',
  },
  USB: {
    icon: () => ['fab', 'usb'],
    iconClass: () => 'has-text-warn',
    title: () => ({ text: `U.S.B.` }),
    content: (_, m) => ({ text: `Cable ${m['usb-connected'] === 'true' ? 'Connected' : 'Disconnected'}.` }),
  },
  TamperPrevented: {
    ...d.dangerStyle,
    content: (_, m) => ({ text: m['tamper-vector'] })
  },
  ActivityManager: {
    ...d.dangerStyle,
    title: (_, m) => ({ text: pascalToHuman(m.eventType) }),
  },
  AudioRecording: {
    title: () => ({ text: 'Audio Recording' }),
    icon: () => 'file-audio',
    iconClass: () => 'has-text-success',
  },
  ConnectivityAction: {
    title: () => ({ text:'Connectivity Change' }),
    icon: () => 'signal',
    menuVariant: () => 'info',
    iconClass: () => 'has-text-info',
  },
  Provisioning: { 
    ...d.successStyle,
    icon: () => 'splotch',
    iconClass: () => d.heartBeat.join(' '),
  },
  Telephony: {
    iconClass: () => 'has-text-info',
    tagClass: () => 'is-info',
    menuVariant: () => 'info',
    icon: (_, meta) => (meta.content.indexOf('blocked') >= 0 || meta.content.indexOf('ended') >= 0)
      ? 'phone-slash'
      : 'phone-flip',
    content: (_, m) => {
      let text = `${m.content}`
      if (m.eventType !== 'SubscriptionChanged') {
        text += ` with ${m['contact-name'] || 'Unknown participant'}`
      }
      const phoneNumber = m['contact-phone-number']
      if (phoneNumber) {
        text += ` ${phoneNumber}`
      }
      text += '.'
      return { text }
    }
  },
  NotificationReceived: {
    iconClass: () => [ 'has-text-primary', ...d.swingingIcon ].join(' '),
    menuVariant: () => 'primary',
  },
  Screenshot: {
    icon: () => 'image',
    iconClass: () => [ 'has-text-info', ...d.tadaIcon ].join(' '),
    menuVariant: () => 'info',
    content: () => ({ text: 'Screenshot was taken in response to the previous event.' })
  },
  WebHistoryChanged: {
    icon: () => '',
    content: (_, m) => ({ mrkdwn: m.content })
  }
}

/**
 * main function for styling by the type
 * e.g. `styleOptionByType(this.n, 'tagClass', 'is-info')`
 */
export function styleOptionByType (n, option, defaultValue) {
  const m = n.metaData
  let style = stylingByType[m.type]
  // by .type
  if (style && style[option] && typeof(style[option]) === 'function') {
    return style[option](n, m)
  }
  // now by .eventType
  style = stylingByEventType[m.eventType]
  if (style && style[option] && typeof(style[option]) === 'function') {
    return style[option](n, m)
  }
  return defaultValue
}
